import { Grid } from "@mui/material";
import React, { useState } from "react";
import { NavHashLink } from "react-router-hash-link";

import "../../src/assets/styles/header.css";
import headerImage from "../assets/image/junaid.png";
import SendIcon from "@mui/icons-material/Send";
import CallMadeIcon from "@mui/icons-material/CallMade";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import Wellcome from "../assets/image/Green_Pink_Boho_Aesthetic_Wedding_Planner_Circle_Logo__1_-removebg-preview.png";
const Header = () => {
  const [open, setOpen] = useState(false);
  const handlePlayVideio = () => {
    setOpen((prev) => !prev);
  };
  return (
    <div id="home" className="header_container">
      <div className="header_content">
        <Grid container>
          <Grid item xs={12} md={1}></Grid>
          <Grid item xs={12} md={6}>
            <div className="header_info">
              <p>M Junaid</p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <p className="header_info_front_end_developer">
                  Frontend Developer
                </p>
              </div>
              <div className="heder_info_about_me">
                <p>
                  <span style={{ fontSize: "22px", color: "white" }}>
                    I'm a React js Developer
                  </span>
                  <span
                    style={{
                      display: "block",
                      marginTop: "5px",
                      fontSize: "16px",
                      width: "70%",
                    }}
                  >
                    Who is passionate about making error-free wevsites with 100%
                    client satisfaction. I have a passion for learning and
                    sharing my knowledge with others as publicly as possible.
                  </span>
                </p>
              </div>
              <div className="header_info_button">
                <div>
                  <NavHashLink className="menu_item" to={"#contact"} smooth>
                    <button className="header_info_button_say_hello">
                      Say Hello
                      <SendIcon />
                    </button>
                  </NavHashLink>
                </div>
                <div style={{ cursor: "pointer" }}>
                  <NavHashLink className="menu_item" to={"#projects"} smooth>
                    <button className="header_info_button_my_works">
                      My Works
                      <CallMadeIcon style={{ cursor: "pointer" }} />
                    </button>
                  </NavHashLink>
                </div>
              </div>
              <div className="header_info_follow_me">
                <p>STAY CONNECTED:</p>
                <div style={{ display: "flex", marginLeft: "10px" }}>
                  <div className="header_info_follow_icon">
                    <a
                      href="https://github.com/MuhammadJunaid01"
                      target="_blank"
                    >
                      <GitHubIcon style={{ color: "#1DA1F2" }} />
                    </a>
                  </div>
                  <div className="header_info_follow_icon">
                    <a
                      href="https://www.linkedin.com/in/mj-juanaid-7358b5216/"
                      target="_blank"
                    >
                      <LinkedInIcon style={{ color: "#1DA1F2" }} />
                    </a>
                  </div>
                  <div className="header_info_follow_icon">
                    <a
                      href="https://twitter.com/MJunaid05176495"
                      target="_blank"
                    >
                      <TwitterIcon style={{ color: "#1DA1F2" }} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={5}>
            <div className="header_image">
              <img src={headerImage} alt="" />
              <div className="play_sample_work_veideo">
                <p onClick={handlePlayVideio}>
                  <PlayCircleIcon className="header_info_play_icon" />
                </p>

                <img src={Wellcome} alt="" />
              </div>
              {/* videio player */}
              <div
                className={
                  open
                    ? " header_info_paly_videio open"
                    : " header_info_paly_videio"
                }
              >
                <p
                  className="header_info_paly_videio_close"
                  onClick={handlePlayVideio}
                >
                  X
                </p>
                <iframe
                  className="header_info_iframe"
                  src="https://www.youtube.com/embed/qhgfIqbiHQ4"
                ></iframe>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="svg_header_fdcontent">
        <NavHashLink
          className="menu_item svg_header_content"
          to={"#about"}
          smooth
        ></NavHashLink>
      </div>
    </div>
  );
};

export default Header;
